import { FC } from 'react';

import Upload from 'components/Upload';
import { logEvent } from 'features/Analytics/analytics';

import { FILE_SIZE } from './fileSize';
import { TreezorUploadProps } from './types';

const onFileSizeExceeded = (fileByteSize: number, maxByteSize: number) => {
  logEvent({
    name: 'Onboarding Upload File Size Exceeded',
    properties: {
      fileByteSize,
      maxByteSize,
    },
    usePrefix: false,
  });
};

/**
 * Reuse the <Upload> component, but add a "size limited" Treezor logic, such as:
 * - Adding the local size limit (different from the initial one - cf Treezor limit)
 * - Tracking the "size limit exceeded" event when triggered
 *
 * This component is mainly used in the onboarding feature to ensure the Treezor
 * file size limit is valid each time a file upload is involved.
 */
const TreezorUpload: FC<TreezorUploadProps> = ({ children, ...props }) => (
  <Upload
    maxByteSizeParam={FILE_SIZE.DEFAULT}
    onFileSizeExceeded={onFileSizeExceeded}
    {...props}
  >
    {children}
  </Upload>
);

export default TreezorUpload;
